var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2402 9.81815V14.4654H18.6984C18.4148 15.96 17.5638 17.2255 16.2875 18.0764L20.182 21.0982C22.4511 19.0037 23.7602 15.9273 23.7602 12.2728C23.7602 11.4219 23.6838 10.6037 23.542 9.81828L12.2402 9.81815Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51485 14.284L4.63649 14.9564L1.52734 17.3782C3.50188 21.2945 7.54885 24 12.2397 24C15.4796 24 18.196 22.9309 20.1815 21.0982L16.2869 18.0764C15.2178 18.7964 13.8542 19.2328 12.2397 19.2328C9.11974 19.2328 6.46891 17.1273 5.51975 14.291L5.51485 14.284Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52741 6.62183C0.709276 8.2363 0.240234 10.0581 0.240234 11.9999C0.240234 13.9417 0.709276 15.7636 1.52741 17.378C1.52741 17.3889 5.52021 14.2799 5.52021 14.2799C5.28021 13.5599 5.13835 12.7963 5.13835 11.9998C5.13835 11.2033 5.28021 10.4398 5.52021 9.71976L1.52741 6.62183Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 4.77818C14.0073 4.77818 15.5782 5.38907 16.8327 6.56727L20.269 3.13095C18.1854 1.18916 15.48 0 12.24 0C7.5491 0 3.50188 2.69454 1.52734 6.62182L5.52002 9.72001C6.46905 6.88361 9.11999 4.77818 12.24 4.77818Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.01e56c24913587d5dae537e1bbec7671.svg";
export { ForwardRef as ReactComponent };